const INITIAL_STATE = {
  especialidades: []
}

export default function especialidadeListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'ESPECIALIDADE_LIST_SET_ESPECIALIDADES':
      return {
        ...state,
        especialidades: action.payload
      }
    case 'ESPECIALIDADE_LIST_CLEAR_ALL':
      return {
        ...state,
        ...INITIAL_STATE
      }
    default:
      return state;
  }
}
